// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"42473084","453":"4c8166d5"}[chunkId] + ".chunk.js";
};